import { render, staticRenderFns } from "./bannerLocker.vue?vue&type=template&id=34806d19&"
import script from "./bannerLocker.vue?vue&type=script&lang=js&"
export * from "./bannerLocker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports